import {StatusPair} from '../models/status-pair';

export class EmploymentStatusData {
  private employmentStatusList: StatusPair[] = [
    new StatusPair('Employed', 'EMPLOYED'),
    new StatusPair('Retired', 'RETIRED'),
    new StatusPair('Selfemployed', 'SELFEMPLOYED'),
    // new StatusPair('At home traider', 'ATHOMETRADER'),
    // new StatusPair('Student', 'STUDENT'),
    // new StatusPair('Unemployed', 'UNEMPLOYED'),
    // new StatusPair('Homemaker', 'HOMEMAKER')
  ];

  public getEmploymentStatusList(): Array<StatusPair> {
    return this.employmentStatusList;
  }
}
